import axios from 'axios';
import { message } from 'antd';

// 强制设置baseURL，防止未配置时走前端host
const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://dev.gateway.com';
console.log('当前API BASE_URL:', baseURL);

const instance = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    // Skip adding headers for login request
    if (!config.url?.includes('/SignIn')) {
      const token = localStorage.getItem('token');

      // 确保headers对象存在
      if (!config.headers) {
        config.headers = {};
      }

      // 设置基础请求头
      config.headers['Content-Type'] = 'application/json';
      config.headers['requestType'] = 'ruika';
      config.headers['clientType'] = 'mobile';

      // 如果有token，添加token相关请求头
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['token'] = token;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
instance.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code === 401) {
      // 清除token和用户信息
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      // 跳转到登录页
      window.location.href = '/login';
      window.location.reload();
      return Promise.reject(new Error('未登录或登录已过期'));
    }
    return res; // 返回完整结构
  },
  (error) => {
    message.error(error.message || '请求失败');
    return Promise.reject(error);
  },
);

export const http = {
  get: (url, config = {}) => {
    const headers = {
      'Content-Type': 'application/json',
      'requestType': 'ruika',
      'clientType': 'mobile',
      ...(config?.headers || {}),
    };
    return instance.get(url, { ...config, headers });
  },
  post: (url, data, config = {}) => {
    const headers = {
      'Content-Type': 'application/json',
      'requestType': 'ruika',
      'clientType': 'mobile',
      ...(config?.headers || {}),
    };
    return instance.post(url, data, { ...config, headers });
  },
  put: (url, data, config = {}) => {
    const headers = {
      'Content-Type': 'application/json',
      'requestType': 'ruika',
      'clientType': 'mobile',
      ...(config?.headers || {}),
    };
    return instance.put(url, data, { ...config, headers });
  },
  delete: (url, config = {}) => {
    const headers = {
      'Content-Type': 'application/json',
      'requestType': 'ruika',
      'clientType': 'mobile',
      ...(config?.headers || {}),
    };
    return instance.delete(url, { ...config, headers });
  },
};